<template>
  <div class="header">
    <a-form 
      class="form" 
      :model="formState"
      :rules="rules"
      layout="vertical" 
    >
      <a-flex wrap="wrap" gap="small" align="flex-end">
        <EntityPicker
          v-model:value="formState.entity"
          default-behavior
          label="Empresa"
          allEntities
        />
        <CampaignPicker
          v-model:value="formState.portfolio"
          default-behavior
          :entity="formState.entity"
          label="Campaña"
          force-enabled
          allCampaign
        />
        <a-form-item name="date" required>
            <template #label>
              Rango de fecha
            </template>
            <plan-range-picker
              v-model="formState.date"
              :config-key="RangeConfigKey.MessagingSearchRange"
              :default-limit="31" />
        </a-form-item>
      </a-flex>
      <div class="back">
        <a-tooltip :title="isGlobalDownloading ?
          'Tiene una descarga pendiente' :
          isDisabled ?
          'Completa los filtros requeridos para descargar el reporte.' : 
          'Se descargarán únicamente los datos de la tabla de acuerdo a los filtros seleccionados.'" 
        >
          <a-button 
            type="primary" 
            :disabled="isDisabled || isGlobalDownloading" 
            :loading="loading"
            @click="handleDownload"
          >
            Descargar 
            <DownloadOutlined />
          </a-button>
        </a-tooltip>
      </div>
    </a-form>
  </div>

  <section class="info">
    Este reporte solo se podrá descargar al
    <br />
    aplicar los filtros
  </section>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from "vue";
import { DownloadOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";

import {
  DownloadDto,
  messagingTicketsService,
} from "@/app/reports/services/MessagingTickets.service";
import { ResponseError } from "@/app/shared/utils/httpManager";
import { RangeConfigKey } from "@/app/shared/utils/planDatePicker";

import PlanRangePicker from "@/app/shared/components/pickers/PlanRangePicker.vue";

const formState: Partial<DownloadDto> = reactive({
  entity: "",
  portfolio: "",
  date: null,
});

const { isGlobalDownloading } = useGlobalDownloadState();

const isDisabled = computed(() => {
  let disabled = false;

  if (!formState.date || formState.date.length < 2) {
    disabled = true;
  }

  for (const key in formState) {
    const currentValue = formState[key as keyof typeof formState];

    if (currentValue === "" ? false : !currentValue) {
      disabled = true;
      break;
    }
  }

  return disabled;
});

const rules = {
  // entity: [{ required: true, message: "Campo requerido" }],
  // portfolio: [{ required: true, message: "Campo requerido" }],
  date: [{ required: true, message: "Campo requerido" }]
};

const loading = ref(false);

const handleDownload = async () => {
  loading.value = true;

  try {
    await messagingTicketsService.download(formState as DownloadDto);
    // downloadFile(response, "strategies_report.xlsx", { useResponseFileName: true });
    message.success("Se ha encolado la descarga");
  } catch (error) {
    let errorMessage = "Ha ocurrido un error";

    if (error instanceof ResponseError) errorMessage = error.getErrorMessage();

    message.error(errorMessage);
    console.error(error);
  }

  loading.value = false;
};
</script>

<style scoped lang="sass">
.header
  margin-top: 12px

.form
  display: flex
  gap: 8px
  justify-content: space-between
  width: 100%

.back
  margin-top: 30px
  text-align: right
  margin-bottom: 10px
  display: flex

.info
  display: grid
  place-content: center
  text-align: center
  color: $gray-7
  font-size: 20px
  font-weight: 400
  margin-top: 150px

</style>
